import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const WORDS = [
  { id: "split", solid: "YIELD", outline: " UP" },
  { id: "brand", solid: "YIELDUP", outline: "" },
  { id: "payoff", solid: "IL RENDIMENTO,", outline: " SU." },
];

const WORD_MS = 850;
const HOLD_MS = 500;

export default function Intro() {
  const [show, setShow] = useState(() => {
    try {
      const forced = new URLSearchParams(window.location.search).has("intro");
      return forced || !sessionStorage.getItem("yu-intro-seen");
    } catch {
      return false;
    }
  });
  const [wordIndex, setWordIndex] = useState(0);

  useEffect(() => {
    if (!show) return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) {
      dismiss();
      return;
    }
    window.__lenis?.stop();
    document.body.style.overflow = "hidden";
    const timers = WORDS.map((_, i) => setTimeout(() => setWordIndex(i), 500 + i * WORD_MS));
    const total = 500 + WORDS.length * WORD_MS + HOLD_MS;
    timers.push(setTimeout(dismiss, total));
    return () => {
      timers.forEach(clearTimeout);
      window.__lenis?.start();
      document.body.style.overflow = "";
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const dismiss = () => {
    try {
      sessionStorage.setItem("yu-intro-seen", "1");
    } catch {}
    setShow(false);
  };

  const word = WORDS[Math.min(wordIndex, WORDS.length - 1)];

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="intro-splash"
          onClick={dismiss}
          initial={{ y: 0 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="fixed inset-0 z-[90] flex cursor-pointer flex-col items-center justify-center bg-[#12100E]"
        >
          <motion.p
            initial={{ opacity: 0, scale: 0.92 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, ease: EASE }}
            className="font-heading text-[26vw] font-black leading-none tracking-tighter text-[#FAF7F2] sm:text-[18vw] lg:text-[13rem]"
          >
            Y<span className="text-[#E05A2C]">U</span>
          </motion.p>

          <div className="mt-6 flex h-16 items-center sm:h-20">
            <AnimatePresence mode="wait">
              <motion.p
                key={word.id}
                data-testid="intro-word"
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -18 }}
                transition={{ duration: 0.4, ease: EASE }}
                className="whitespace-nowrap font-heading text-2xl font-black uppercase tracking-tight text-[#FAF7F2] sm:text-5xl"
              >
                {word.solid}
                {word.outline && <span className="text-outline">{word.outline}</span>}
              </motion.p>
            </AnimatePresence>
          </div>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.6 }}
            className="mt-10 font-mono text-xs uppercase tracking-[0.25em] text-[#A89F91] sm:text-xs"
          >
            Revenue management · Sicilia
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
